import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2021-12-19'
        tag='Poshmark'
        title='The Poshmark Holiday Guide: What Items to Sell and How To Boost Your Sales'
      >
        <p>
          There’s so much to love about the holiday season. And of course, one of these is the thrill of giving and
          receiving gifts. Whether you’re on the seller or buyer side (or both), the months that cover Thanksgiving,
          Christmas, and New Year are exciting times for making purchases, more so if using a reselling platform such as
          Poshmark, where selections are virtually endless.{' '}
        </p>
        <p>Are you a Poshmark seller? Ride the waves of holiday sales to the peak with these easy tips. </p>

        <h3>Get clues from Poshmark resource materials.</h3>
        <p>
          Poshmark releases its holiday trend report every first week of November. It is a valuable data-driven report
          that predicts trends and hot merchandise to sell based on its shoppers’ searches and year-on-year volume
          growth. It is a must-read to gain insights into the categories and brands that sell well on Poshmark during
          this festive season in different departments (Women’s, Men’s, Kids, Home, Luxury Items).{' '}
        </p>
        <p>
          Some of the items that consistently show up on searches – indicating a strong market for them – include{' '}
          <em>seasonal clothing and accessories</em> such as Christmas dresses and winter essentials like puffer jackets
          and coats and popular <em>luxury purchases</em> like Cartier bracelets that are perfect for gifting. Top
          brands differ depending on the department, but certain categories are saleable across the board, such as
          jackets, blazers, sweaters, and jeans or pants.{' '}
        </p>
        <p>
          The holiday trend report surmises that the popularity of certain items or brands may be driven by the social
          media influencers or celebrities who own or support them. Brands that embrace environmental awareness and
          practice sustainability in their production have also been driving a brand’s popularity. You may read the
          entire report <a href='https://blog.poshmark.com/2021/11/08/the-2021-holiday-trend-report/'>here</a> and check
          out the{' '}
          <a href='https://blog.poshmark.com/2021/11/26/the-2021-poshmark-holiday-gift-guide/'>
            Poshmark holiday gift guide
          </a>
          , too, if you need more specific inspirations to add to your closet inventory.{' '}
        </p>

        <h3>Plan and prepare like a pro. </h3>
        <p>
          According to the current Poshmark Holiday Trend Report, 38% of buyers start their holiday season shopping in
          October, while over 61% do just before Thanksgiving. In addition, the purchasing power will remain strong
          throughout December until early January, thanks to cash bonuses at work and money gifts.
        </p>
        <p>
          Planning is key if you want to better prepare for this busy season. Armed with knowledge from the past trend
          reports (the most searched items mentioned earlier will most likely still be the same next year), you could
          get a good grasp of what to offer. Keep that in mind as you source new items as early as August or September
          to cater to the early-bird shoppers in October.
        </p>
        <p>
          Plan other aspects of your reselling business to help make the stressful holiday season a breeze. Tasks like
          doing the product photoshoot early, plotting a schedule for creating and posting your listings, stocking up on
          shipping supplies, and more, can all contribute to making you feel on top of things during crunch time.{' '}
        </p>

        <h3>Promote and share. Repeat. </h3>
        <p>
          Sourcing or thrifting items to add to your closet early will leave you with more time to be creative and think
          of promotions for your reselling business. Make use of your existing social media accounts, or even create new
          ones dedicated to your Poshmark closet, whether it’s on Instagram, Pinterest, or YouTube. You can create
          #PoshLife content, as well as put together simple, eye-catching, holiday-themed layouts using selected items
          from your closet – curated like your very own gift guide.{' '}
        </p>
        <p>
          Setting aside time to consciously grow your followers and regularly do shares (both self-shares and community
          shares) would also help your closet. This is true on regular days, especially during the holiday season, when
          most people tend to purchase instead of just looking around. Therefore, your closet needs all the exposure and
          visibility it can get. For this strategy, consider using OneShop in automating these promotional tasks. Sign
          up <a href='https://tools.oneshop.com/'>here</a> for its free 7-day trial today.{' '}
        </p>

        <h3>Add warmth with a personal touch. </h3>
        <p>
          Hey, it’s the most wonderful time of the year for a reason! Help spread the holiday cheer with a more
          personalized approach to selling. Reach out to those who’ve shown interest in your listings and offer private
          discounts, price drops, or bundles. Throw in a lovely handwritten note in nice stationery and some sweets like
          Starlight mints or a candy cane – even a free top or accessories for big-ticket items like a designer handbag
          – before shipping the package out. We bet the thoughtful gesture won’t go unnoticed and might even win you
          repeat customers!{' '}
        </p>
        <p>
          As with any business venture, planning wisely and paying attention to details can do wonders to your Poshmark
          business holiday season and beyond.
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
